import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import FormControl from "./FormControl.vue";
import Checkbox from "../Checkbox.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FormCheckbox',
    props: /*@__PURE__*/ _mergeModels({
        label: { type: String, required: true },
        name: String,
        modifier: { type: String, default: 'm' },
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup: function (__props) {
        var value = _useModel(__props, "modelValue");
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(FormControl, null, {
                default: _withCtx(function () { return [
                    _createVNode(Checkbox, {
                        label: __props.label,
                        name: __props.name,
                        modifier: __props.modifier,
                        modelValue: value.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((value).value = $event); })
                    }, null, 8 /* PROPS */, ["label", "name", "modifier", "modelValue"])
                ]; }),
                _: 1 /* STABLE */
            }));
        };
    }
});
